import styled from 'styled-components';
import { Title, SubTitle } from '@minerva-analytics/pantheon';
import { WHITE, EEL, SEA_FOAM, MOBILE, TABLET, LARGE} from '../../theme';

const LandingPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  color: ${WHITE};
  width: 100%;
  min-height: 100%;
  @media (max-width: 37.5rem) {
    align-items: center;
  }
`;

const BarSection = styled.div`
  margin-top: ${(props) => (props.articleThanks ? `6.25rem` : `5vh`)};
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 37.5rem) {
    margin-top: ${(props) => (props.articleThanks ? `6.25rem` : `2.5rem`)};
  }
`;

const LandingPageContent = styled.div`
  margin: ${(props) => (props.articleThanks ? `4.375rem 0rem 0rem 0rem` : `7vh auto 0 auto`)};
  padding-bottom: 7rem;
  display: block;
  max-width: 81.25rem;
  width: 80%;
  text-align: left;
  color: ${WHITE};
  font-family: Roboto, sans-serif;
  p {
    font-weight: 300;
  }
  transition: 500ms ease;
  opacity: ${({ state }) => (state === `entered` ? 1 : 0)};
  transform: translateX(${({ state }) => (state === `entered` ? 0.3125 : 0)}rem);
  @media (max-width: ${LARGE}) {
    width: 90%;
  }
  @media (max-width: ${MOBILE}) {
    padding-bottom: 4.6875rem;
    padding-top: 1rem;
  }

`;

const Headline = styled(Title)`
  &&& {
    margin: 0 0 1.5625rem 0;
    font-size: ${(props) => (props.articleThanks ? `1.625rem` : `3.5rem`)};
    font-weight: 700;
    width: 100%;
    text-align: ${(props) => (props.articleThanks ? `left` : `3.5rem`)};
    @media (max-width: ${TABLET}) {
      font-size: ${(props) => (props.articleThanks ? `1.625rem` : `5rem`)};
      margin-bottom: 0.9375rem;
    }
    @media (max-width: ${MOBILE}) {
      font-size: ${(props) => (props.articleThanks ? `1.625rem` : `2.9rem`)};
    }
  }
`;

const IntroCategorySection = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 1rem;
`;

const Intro = styled(SubTitle)`
  &&& {
    margin: ${(props) => (props.thanks ? `0` : `0 0 3.125rem 0`)};
    font-weight: 300;
    line-height: 2rem;
    max-width: ${(props) => (props.thanks ? `unset` : `34.375rem`)};
    font-size: ${(props) => (props.articleThanks ? `1.125rem` :  `1.25rem`)};
    padding-top: 0.625rem;
    a {
      font-weight: bold;
      border-bottom: solid 2px ${SEA_FOAM};
      text-decoration: none;
    }
    @media (max-width: 37.5rem) {
      font-size: 1.2rem;
      line-height: 1.75rem;
    }
    @media only screen and (max-width: ${MOBILE}) {
      font-size: 1.125rem;
    }
    span {
      font-weight: bold;
    }
  }
`;

const CategorySection = styled.div`
  display: flex;
  min-height: 1rem;
  align-items: center;
  padding-top: 1rem;

  @media (max-width: ${TABLET}) {
    display: none;
  }
`;
const Category = styled.p`
  margin: 0;
  text-align: center;

  @media (max-width: 37.5rem) {
    font-size: 0.7rem;
  }
`;

const CyanDivider = styled.div`
  width: 2px;
  height: 1.1rem;
  background: ${EEL};
  margin: 0 0.5rem;
  flex-shrink: 0;
`;

const BarTextSection = styled.div`
  display: flex;
  margin-bottom: 4.375rem;

  @media (max-width: 37.5rem) {
    margin-bottom: 1.875rem;
  }
`;


export {
  Headline,
  BarTextSection,
  IntroCategorySection,
  Intro,
  CategorySection,
  Category,
  LandingPageContent,
  LandingPageContainer,
  CyanDivider,
  BarSection,
};
